import axiosInstanceApiGateway from 'config/apiServiceApiGateway'

import type {
  SkuReviewProductListParamsType,
  SkuReviewProductListResponseType,
  MarkReviewPayloadType,
  ProductOverviewParamsType,
  ProductOverviewResponseType,
  ProductTrendParamsType,
  ProductTrendResponseType,
  DailyDistributionParamsType,
  DailyDistributionResponseType,
  ProductDetailResponseType,
  HubSummaryResponseType,
  HubListParamsType,
  HubListResponseType,
  SkuReviewHubDistributionParamsType,
  HubDistributionResponseType,
} from '../@types/dpTypes'

const ANALYTICS_BASE = '/analytics-data/internal/v1'
const COMMERCIAL_BASE = '/commercial/internal/v1'

export const getSkuReviewProductList = (params?: SkuReviewProductListParamsType) =>
  axiosInstanceApiGateway.Get<SkuReviewProductListResponseType, true>({
    url: `${ANALYTICS_BASE}/scms/forecasts/products`,
    params,
  })

export const markProductReviewAPI = (payload: MarkReviewPayloadType) =>
  axiosInstanceApiGateway.Patch<{ data: string }, true>({
    url: `${COMMERCIAL_BASE}/scms/forecasts/products`,
    data: payload,
  })

export const getProductDetail = (productId: number) =>
  axiosInstanceApiGateway.Get<ProductDetailResponseType, true>({
    url: `${ANALYTICS_BASE}/scms/forecasts/products/${productId}`,
  })

export const getProductOverview = (productId: number, params?: ProductOverviewParamsType) =>
  axiosInstanceApiGateway.Get<ProductOverviewResponseType, true>({
    url: `${ANALYTICS_BASE}/scms/forecasts/products/${productId}/overview`,
    params,
  })

export const getProductTrend = (productId: number, params?: ProductTrendParamsType) =>
  axiosInstanceApiGateway.Get<ProductTrendResponseType, true>({
    url: `${ANALYTICS_BASE}/scms/forecasts/products/${productId}/trend`,
    params,
  })

export const getProductDailyDistribution = (
  productId: number,
  params?: DailyDistributionParamsType,
) =>
  axiosInstanceApiGateway.Get<DailyDistributionResponseType, true>({
    url: `${ANALYTICS_BASE}/scms/forecasts/products/${productId}/daily-distribution`,
    params,
  })

export const getProductHubSummary = (productId: number) =>
  axiosInstanceApiGateway.Get<{ data: HubSummaryResponseType }, true>({
    url: `${ANALYTICS_BASE}/scms/forecasts/products/${productId}/hub-summary`,
  })

export const getProductHubList = (productId: number, params?: HubListParamsType) =>
  axiosInstanceApiGateway.Get<HubListResponseType, true>({
    url: `${ANALYTICS_BASE}/scms/forecasts/sku-review/products/${productId}/hubs`,
    params,
  })

export const getSkuReviewHubDistribution = (
  productId: number,
  params?: SkuReviewHubDistributionParamsType,
) =>
  axiosInstanceApiGateway.Get<HubDistributionResponseType, true>({
    url: `${ANALYTICS_BASE}/scms/forecasts/sku-review/products/${productId}/hub-distribution`,
    params,
  })
